import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core'
import { I18nService, LgType } from '../../services/prod/i18n.service'

export type ServicesType = {
  id: number
  title: string
  description: string
  price: number
  src: string
}

@Component({
  selector: 'bmcore-services-block',
  templateUrl: './bmcore-services-block.component.html',
  styleUrls: ['./bmcore-services-block.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class BmcoreServicesBlockComponent implements OnInit {
  lg: LgType
  services: Array<ServicesType> = [
    {
      id: 1,
      title: 'Сведение и мастеринг',
      description:
        'Короткое редактируемое продюсером описание, с ограничением по символам, чтобы всё умещалось в одну-две строки. Идейные соображения высшего порядка, также требуют от нас анализа дальнейших направлений развития.',
      price: 1000,
      src: 'service-stub-1.jpg'
    },
    {
      id: 2,
      title: 'Совместный бит с ProducerName',
      description:
        'Короткое редактируемое продюсером описание, с ограничением по символам, чтобы всё умещалось в одну-две строки. Идейные соображения высшего порядка, также требуют от нас анализа дальнейших направлений развития.',
      price: 2500,
      src: 'service-stub-2.jpg'
    }
  ]

  constructor(private i18nService: I18nService) {}

  ngOnInit() {
    this.lg = this.i18nService.getLanguageForPage()
    this.getServices()
  }

  getServices() {
    return this.services
  }
}
